export default __webpack_public_path__ + "static/media/yellow.befe5e45.png";